const registry = new Map<number, () => Promise<void>>()

export function registerSectionFlush(id: number, fn: () => Promise<void>) {
  registry.set(id, fn)
}

export function unregisterSectionFlush(id: number) {
  registry.delete(id)
}

export async function flushAllSections(): Promise<void> {
  await Promise.all(Array.from(registry.values()).map((fn) => fn()))
}
